import { html, TemplateResult } from "lit";
import { HolidaysCalendar } from "./holidaysCalendar";
import calendarCss from "../../calendar.css";

const arrow = html`
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 292.359 292.359" style="enable-background:new 0 0 292.359 292.359;"
        xml:space="preserve">
    <g>  
        <path d="M222.979,5.424C219.364,1.807,215.08,0,210.132,0c-4.949,0-9.233,1.807-12.848,5.424L69.378,133.331
            c-3.615,3.617-5.424,7.898-5.424,12.847c0,4.949,1.809,9.233,5.424,12.847l127.906,127.907c3.614,3.617,7.898,5.428,12.848,5.428
            c4.948,0,9.232-1.811,12.847-5.428c3.617-3.614,5.427-7.898,5.427-12.847V18.271C228.405,13.322,226.596,9.042,222.979,5.424z"
        />
    </g>
  </svg>  
`;

/** Handles calendar template. */
export function holidaysCalendarTemplate(this: HolidaysCalendar): TemplateResult {
    return html`
        <style>
            ${calendarCss}
        </style>
        <div class="year-controls">
            <div class="arrow left" @click=${this.onPrevYearButtonClick.bind(this)}>
                ${arrow}
            </div>
            ${this.currentYear}
            <div class="arrow right" @click=${this.onNextYearButtonClick.bind(this)}>
                ${arrow}
            </div>
        </div>
        <div class="calendar"></div>
        <div class="actions">
            <fw-button class="submit-button" type="button" @click=${this.handleConfirmButtonClick.bind(this)}>Применить</fw-button>
            <fw-button type="button" color="secondary" @click=${this.handleCancelButtonClick.bind(this)}>Отмена</fw-button>
        </div>
    `;
}
